<template>
    <tab-frame>
        <div class="container" wxscrollable>
            <ve-line :data="lineData" :extend="lineExtend" :settings="lineSettings"></ve-line>
            <ve-ring :data="ringData" :settings="ringSettings" height="300px"></ve-ring>
        </div>
    </tab-frame>
</template>

<script>
    import VeLine from 'v-charts/lib/line.common';
    import VeRing from 'v-charts/lib/ring.common';
    export default {
        name: "Stats",
        components: {
            've-line': VeLine,
            've-ring': VeRing,
        },
        data() {
            return {
                lineExtend:{
                    'xAxis.0.axisLabel.rotate': 45
                },
                lineSettings: {
                    area: true,
                },
                lineData: {
                    columns: [],
                    rows: []
                },
                ringSettings: {
                    radius: [10, 100],
                    offsetY: 160,
                },
                ringData: {
                    columns: [],
                    rows: []
                }
            }
        },
        created() {
            this.getLineData();
            this.getRingData();
        },
        methods: {
            async getLineData() {
                let res = await this.$axios.get(`/applycheck/applytendency`);
                this.lineData.rows = res.data;
                for(let p in res.data[0]) {
                    this.lineData.columns.push(p);
                }
            },
            async getRingData() {
                let res = await this.$axios.get(`/applycheck/applydistribution`);
                this.ringData.rows = res.data;
                for(let p in res.data[0]) {
                    this.ringData.columns.push(p);
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .container {
        height: calc(100vh - 55px);
        width: 100%;
        padding: 15px 0 0;
        overflow: scroll;
    }
</style>